var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoTexel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h32a4 4 0 014 4v32a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#3E71A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.857 5H7.143C5.959 5 5 5.96 5 7.143v25.714C5 34.041 5.96 35 7.143 35h25.714C34.041 35 35 34.04 35 32.857V7.143C35 5.959 34.04 5 32.857 5z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.142 33.286a.429.429 0 100-.857.429.429 0 000 .857zM7.142 7.572a.429.429 0 100-.858.429.429 0 000 .857zM32.857 7.572a.429.429 0 100-.858.429.429 0 000 .857zM32.857 33.286a.429.429 0 100-.857.429.429 0 000 .857z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19a5 5 0 100-10 5 5 0 000 10z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.538 8.964c.741 0 1.123.87.651 1.415l-.045.049-6.68 6.68h6.931v1.713h-9c-.741 0-1.123-.87-.651-1.414l.045-.049 6.679-6.68H8.752V8.965h8.786zM18.395 21.607v1.714h-5.143v5.357c0 .648.308 1.038.793 1.07l.064.002h4.286v1.714h-4.286c-1.504 0-2.525-1.167-2.57-2.682l-.001-.104v-5.357H8.752v-1.714h9.643zM22.798 21.607l2.117 4.071H27.4l2.117-4.071h1.932l-2.562 4.928 2.562 4.93h-1.932L27.4 27.391h-2.485l-2.117 4.072h-1.932l2.563-4.928-2.563-4.93h1.932z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgZoTexel;